import { Flex, Progress } from "antd";
import React from "react";

const TotalWeight = ({ percent = 0, totalPercentage = 100 }: any) => {
  return (
    <div className="bg-white rounded-lg border border-main-border p-4 w-full">
      <Flex gap={12} align="center">
        <Progress
          percent={Math.min(percent, totalPercentage)}
          size="default"
          strokeColor="#7c3aed"
          trailColor="#f3f4f6"
          className="w-full"
          showInfo={false}
        />
        <div className="text-base font-semibold text-blue-600">
          {percent}%
        </div>
      </Flex>
    </div>
  );
};

export default TotalWeight;